import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=4051010a&scoped=true"
import script from "./PaginationBar.vue?vue&type=script&lang=js"
export * from "./PaginationBar.vue?vue&type=script&lang=js"
import style0 from "./PaginationBar.vue?vue&type=style&index=0&id=4051010a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051010a",
  null
  
)

export default component.exports